import { Path } from "../../../../core/routing/path";
import { ACCOUNT_QUERY_PARAM } from "../utils/use-selected-account";

export const navigateToAccountTransactions = (history: any, accountId: string) => {
  history.push(`${Path.AccountTransactions}?${ACCOUNT_QUERY_PARAM}=${accountId}`);
};
